/** Formatovani cisel a datumu. Data cisla s pevnou sirkou cislic (UI.md). */

export const num = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : new Intl.NumberFormat('cs-CZ').format(value);

export const pct = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : `${new Intl.NumberFormat('cs-CZ').format(value)} %`;

export const money = (value: string | number | null | undefined, currency = 'EUR'): string => {
  if (value === null || value === undefined) return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency }).format(n);
};

export const date = (value: string | Date | null | undefined, timeZone?: string): string => {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('cs-CZ', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    ...(timeZone ? { timeZone } : {}),
  }).format(d);
};

export const dateTime = (value: string | Date | null | undefined, timeZone?: string): string => {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('cs-CZ', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...(timeZone ? { timeZone } : {}),
  }).format(d);
};

/** Pocet dni od nynejska; kladne do budoucnosti. */
export const daysFrom = (
  now: string | Date,
  value: string | Date | null | undefined,
): number | null => {
  if (!value) return null;
  const a = now instanceof Date ? now : new Date(now);
  const b = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(b.getTime())) return null;
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
};
